<ngx-loading [show]="loading"></ngx-loading>
<app-header></app-header>
<div style="min-height:800px;">
    <!-- [config]="{animationType: ngxLoadingAnimationTypes.circleSwish, primaryColour: primaryColour, backdropBorderRadius: '3px'} [template]="loadingTemplate"" -->
    <div class="body-content outer-top-xs" id="top-banner-and-menu">
        <div class="container">
          <div class="row">
            
                <div class="col-xs-12 col-sm-12 sidebar" [ngClass]="{'col-md-3': isaccesswithlogin=='1','displaynone': isaccesswithlogin=='0'}">
            <app-side-menu></app-side-menu>
        </div>
        
        <div class="col-xs-12 col-sm-12 bgwhite" [ngClass]="{'col-md-12': isaccesswithlogin=='0','col-md-9': isaccesswithlogin=='1'}">
<router-outlet></router-outlet>
</div>  
</div>  
</div>
</div>
</div>
<!-- *ngIf="url !== '/404'" -->
<app-footer></app-footer>